"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIconByLinkType = void 0;
var _icons = require("@ori-ui/icons");
var _net = require("../models/graphql-types/net");
var _jsxRuntime = require("react/jsx-runtime");
const getIconByLinkType = linkType => {
  switch (linkType) {
    case _net.NavigationLinkType.Catalogue:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Catalogue, {});
    case _net.NavigationLinkType.FocusPage:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.DiscountTag, {});
    case _net.NavigationLinkType.Inspiration:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Products, {});
    case _net.NavigationLinkType.BeautyTips:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.WhatsNew, {});
    case _net.NavigationLinkType.Gifts:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Gift, {});
    default:
      return null;
  }
};
exports.getIconByLinkType = getIconByLinkType;
